<template>
  <div class="container mt-5">
    <CCard
        class="shadow border"
        :style="{
        borderRadius: '20px',
        boxShadow: '0 8px 20px rgba(0, 0, 0, 0.15)',
        transition: 'box-shadow 0.3s ease'
      }"
    >
      <CCardHeader class="fw-bold fs-5">
        Write your policy here
        <div class="card-header-actions">
          <a
              href="https://github.com/surmon-china/vue-quill-editor"
              rel="noreferrer noopener"
              target="_blank"
              class="card-header-action"
          >
            <small class="text-muted">docs</small>
          </a>
        </div>
      </CCardHeader>

      <CCardBody>
        <quill-editor
            v-model="content"
            :options="editorOptions"
            style="min-height: 200px"
        />
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import Vue from 'vue'
import VueQuillEditor from 'vue-quill-editor'

// Quill styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.use(VueQuillEditor)

export default {
  name: 'text-editors',
  data () {
    return {
      content: '<p></p>',
      editorOptions: {
        placeholder: 'Type your policy here...',
        theme: 'snow'
      }
    }
  }
}
</script>
